import React, {useState} from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

import { mind_pattern_variant } from '../../../core/constants';

import icon_team_group from '../../../assets/img/icon-team-group.svg';
import icon_team_leader from '../../../assets/img/icon-team-leader.svg';

export const MindPatternsGroupedMembers = ({ mindPatternsGrouped, areas }) => {
    const [modal, setModal] = useState(false);
    const [selectedPattern, setSelectedPattern] = useState('');
    const toggle = () => setModal(!modal);

    const handlePatternClick = (pattern) => {
        setSelectedPattern(pattern);
        setModal(true);
    };

    let mind_patterns = null

    if (selectedPattern) {
      mind_patterns = selectedPattern.split("").map((mp, k) => {

        let mPattern = areas.items.find((item) => item.code === mp )

        return <div key={mp + k} className={`text-center item-mind-patterns item-mind-patterns-${mPattern.name.toLowerCase()}`}>
          <div>
            <div className={`mb-2 rounded-circle item-mind-pattern-icon p-1 bg-${mPattern.name.toLowerCase()}`}>
              <img src={mPattern.icon} alt={mPattern.name} width={40} height={'auto'} className={`${mPattern.name.toLowerCase() !== 'auditory' ? 'icon-inverse' : ''}`}/>
            </div>
            <p className="font-weight-semibold">{mPattern.name}</p>
          </div>
        </div>

      })
    }

    return (
        <>
        <div className="mind-patterns-grouped-members row row-cols-lg-2 row-cols-1">
            {Object.keys(mindPatternsGrouped).map((pattern, index) => {
                return <div className='col mb-3' key={index} id={pattern}>
                    <div key={pattern} onClick={() => handlePatternClick(pattern)} className="cursor-pointer d-flex px-2 mind-pattern-group border rounded-lg justify-content-between align-items-center py-2">
                        <div className="d-flex">
                            {pattern.split("").map((mp, k) =>
                                <div key={`mind-pattern-${k}`} className={`mx-1 letter-mind-patterns border-mind-pattern border-mind-pattern-${mp.toLowerCase()}`}>
                                    {mp}
                                </div>
                            )}
                        </div>
                        <div>
                            <p className="font-weight-semibold mb-0">
                                {mindPatternsGrouped[pattern].members?.length}
                                <span className="ico ml-1">
                                    <img src={icon_team_group} className='icon-team-group' width="20" height="auto" alt={"Group"} />
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            })}
        </div>

        {selectedPattern && 
            <Modal isOpen={modal} toggle={toggle} size='sm' className="w-100 modal-dialog-summary float-right">
                <ModalHeader toggle={toggle} className='pb-0'></ModalHeader>
                <ModalBody className='pt-2'>
                    <div className='d-flex align-items-center mb-4'>
                        <h2 className='libre-caslon-text-regular text-capitalize mb-0 h4'>Working with {selectedPattern}s</h2>
                    </div>

                    <div className="d-flex justify-content-around gap-10 mb-2">
                        {mind_patterns}
                    </div>
                    {mindPatternsGrouped[selectedPattern].mind_pattern_info && <div className='mb-3'><p className='small'>{mindPatternsGrouped[selectedPattern].mind_pattern_info}</p></div>}

                    <div className="member-list">
                        <h5>Members with {selectedPattern} ({mindPatternsGrouped[selectedPattern].members?.length})</h5>
                        {mindPatternsGrouped[selectedPattern].members.map((member, index) => (
                            <div key={index} className="member-item mb-2 d-flex align-items-center border rounded-lg p-2">
                                <div className="d-flex align-items-center text-reset text-decoration-none flex-fill">
                                    <div className="pr-2"><img width="32" height="32" alt="Name2367" src={member.avatar}/></div>
                                    <div>
                                        <p className="h6 mb-1 text-truncate text-nowrap">{member.first_name} {member.last_name}
                                            {'leaderMember?.user_id' === member.id && <img className="talents-icon-arrow ml-2 mb-1" src={icon_team_leader} width="16" height="auto" alt="Team Leader" />}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                        
                    </div>
                </ModalBody>
            </Modal>
        }
        </>
    );
};
